module.exports = __webpack_public_path__ + "static/media/Demographic_options.152e4015.svg";